document.addEventListener('DOMContentLoaded', initFaqPage);

function initFaqPage() {
  const page = document.querySelector('[data-faq-page]');
  if (!page) return;

  const container = page.querySelector('[data-faq-sections]');
  const config = window.FaqPageConfig || {};
  if (!container) return;

  fetch(config.dataUrl)
    .then((res) => res.json())
    .then((sections) => {
      renderFaq(sections, container);
    })
    .catch(() => {
      container.innerHTML = '<p class="faq-page__error">Unable to load FAQ content.</p>';
    });
}

function renderFaq(sections, container) {
  let globalIndex = 0;
  const openIds = new Set();

  container.innerHTML = sections
    .map((section, sectionIndex) => {
      const itemsHtml = section.items
        .map((item, itemIndex) => {
          const id = `${sectionIndex}-${itemIndex}`;
          const index = globalIndex++;
          return `
            <div class="faq-page__item">
              <button
                type="button"
                class="faq-page__question"
                data-faq-toggle="${escapeAttr(id)}"
                aria-expanded="false"
                aria-controls="faq-answer-${index}"
                data-testid="button-faq-${index}"
              >
                <span class="faq-page__question-text">${escapeHtml(item.q)}</span>
                <svg class="faq-page__chevron" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                  <path d="m6 9 6 6 6-6"/>
                </svg>
              </button>
              <div
                class="faq-page__answer"
                id="faq-answer-${index}"
                data-faq-panel="${escapeAttr(id)}"
                hidden
              >
                <p data-testid="text-faq-answer-${index}">${escapeHtml(item.a)}</p>
              </div>
            </div>`;
        })
        .join('');

      return `
        <section class="faq-page__group" data-testid="text-faq-section-${sectionIndex}">
          <h2 class="faq-page__group-title">${escapeHtml(section.title)}</h2>
          <div class="faq-page__list">${itemsHtml}</div>
        </section>`;
    })
    .join('');

  container.querySelectorAll('[data-faq-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.dataset.faqToggle;
      const panel = container.querySelector(`[data-faq-panel="${id}"]`);
      if (!panel) return;

      const isOpen = openIds.has(id);
      if (isOpen) {
        openIds.delete(id);
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-open');
        panel.hidden = true;
      } else {
        openIds.add(id);
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('is-open');
        panel.hidden = false;
      }
    });
  });
}

function escapeHtml(str) {
  return String(str ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function escapeAttr(str) {
  return escapeHtml(str).replace(/'/g, '&#39;');
}
